// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Env from "../../core/Env.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Json from "../../primitives/Json.res.js";
import * as React from "react";
import * as Banner from "../../resources/feedback-indicators/Banner.res.js";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Select from "../../resources/selection-and-input/Select.res.js";
import * as Request from "../../core/Request.res.js";
import * as Tooltip from "../../resources/overlays/Tooltip.res.js";
import * as Scaffold from "../../bundles/Scaffold/Scaffold.res.js";
import * as AsyncData from "../../primitives/AsyncData.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as SearchBar from "../../resources/selection-and-input/SearchBar.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as CountBadge from "../../resources/feedback-indicators/CountBadge.res.js";
import * as DeviceName from "../../modules/Device/DeviceName.res.js";
import * as EmptyState from "../../resources/layout-and-structure/EmptyState.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as Illustration from "../../resources/images-and-icons/Illustration.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as CatalogProduct from "../../modules/Catalog/CatalogProduct.res.js";
import * as SessionTracker from "../../core/SessionTracker.res.js";
import * as CanarySeparator from "../../resources/layout-and-structure/CanarySeparator.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as StockActivityKind from "../../modules/StockActivity/StockActivityKind.res.js";
import * as TableDatetimeCell from "../../resources/tables/TableDatetimeCell.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as StockActivityReason from "../../modules/StockActivity/StockActivityReason.res.js";
import * as RequestOpenStorageUrl from "../../core/RequestOpenStorageUrl.res.js";
import * as SelectDateRangeFilter from "../../resources/selection-and-input/SelectDateRangeFilter.res.js";
import * as StockActivityTypeTableCell from "../../modules/StockActivity/StockActivityTypeTableCell.res.js";
import * as StockActivitySourceTableCell from "../../modules/StockActivity/StockActivitySourceTableCell.res.js";
import * as StockActivityQuantityTableCell from "../../modules/StockActivity/StockActivityQuantityTableCell.res.js";
import * as LegacyProductReferenceTableCell from "../../modules/Product/LegacyProductReferenceTableCell.res.js";
import * as ApolloClient__React_Hooks_UseQuery from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseQuery.res.js";

let Raw = {};

let query = Client.gql(["query StockActivityPageQuery($search: String, $before: String, $after: String, $first: Int, $last: Int, $filterBy: InputStockActivitiesQueryFilter)  {\nstockActivities(search: $search, before: $before, after: $after, first: $first, last: $last, filterBy: $filterBy)  {\n__typename  \npageInfo  {\n__typename  \nstartCursor  \nendCursor  \n}\n\nedges  {\n__typename  \nnode  {\n__typename  \nid  \nvariant  {\n__typename  \nid  \ncku  \nformattedName  \nformattedDescription  \nstockKeepingUnit  \ncapacityPrecision  \ncapacityUnit  \nbulk  \nproduct  {\n__typename  \ncolor  \n}\n\n}\n\nkind  \nreason  \ncomment  \nquantity  \ncreatedAt  \nshop  {\n__typename  \nname  \n}\n\ndevice  {\n__typename  \nname  \nslug  \n}\n\n}\n\n}\n\ntotalCount  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.stockActivities;
  let value$2 = value$1.pageInfo;
  let value$3 = value$2.startCursor;
  let value$4 = value$2.endCursor;
  let value$5 = value$1.edges;
  return {
    stockActivities: {
      __typename: value$1.__typename,
      pageInfo: {
        __typename: value$2.__typename,
        startCursor: !(value$3 == null) ? value$3 : undefined,
        endCursor: !(value$4 == null) ? value$4 : undefined
      },
      edges: value$5.map(value => {
        let value$1 = value.node;
        let value$2 = value$1.variant;
        let tmp;
        if (value$2 == null) {
          tmp = undefined;
        } else {
          let value$3 = value$2.stockKeepingUnit;
          let value$4 = value$2.capacityPrecision;
          let value$5 = value$2.capacityUnit;
          let value$6 = value$2.bulk;
          let value$7 = value$2.product;
          let value$8 = value$7.color;
          let tmp$1;
          if (value$8 == null) {
            tmp$1 = undefined;
          } else {
            let tmp$2;
            switch (value$8) {
              case "AMBER" :
                tmp$2 = "AMBER";
                break;
              case "BLACK" :
                tmp$2 = "BLACK";
                break;
              case "BLOND" :
                tmp$2 = "BLOND";
                break;
              case "DARK" :
                tmp$2 = "DARK";
                break;
              case "ORANGE" :
                tmp$2 = "ORANGE";
                break;
              case "RED" :
                tmp$2 = "RED";
                break;
              case "ROSE" :
                tmp$2 = "ROSE";
                break;
              case "WHITE" :
                tmp$2 = "WHITE";
                break;
              default:
                throw {
                  RE_EXN_ID: "Not_found",
                  Error: new Error()
                };
            }
            tmp$1 = tmp$2;
          }
          tmp = {
            __typename: value$2.__typename,
            id: value$2.id,
            cku: Scalar.CKU.parse(value$2.cku),
            formattedName: value$2.formattedName,
            formattedDescription: value$2.formattedDescription,
            stockKeepingUnit: !(value$3 == null) ? value$3 : undefined,
            capacityPrecision: !(value$4 == null) ? value$4 : undefined,
            capacityUnit: !(value$5 == null) ? value$5 : undefined,
            bulk: !(value$6 == null) ? value$6 : undefined,
            product: {
              __typename: value$7.__typename,
              color: tmp$1
            }
          };
        }
        let value$9 = value$1.kind;
        let tmp$3;
        switch (value$9) {
          case "CREDIT_MEMO" :
            tmp$3 = "CREDIT_MEMO";
            break;
          case "DELIVERY" :
            tmp$3 = "DELIVERY";
            break;
          case "DELIVERY_RECEIPT" :
            tmp$3 = "DELIVERY_RECEIPT";
            break;
          case "INCOMING_TRANSFER" :
            tmp$3 = "INCOMING_TRANSFER";
            break;
          case "LOSS" :
            tmp$3 = "LOSS";
            break;
          case "OUTGOING_TRANSFER" :
            tmp$3 = "OUTGOING_TRANSFER";
            break;
          case "RECEPTION" :
            tmp$3 = "RECEPTION";
            break;
          case "REFUND" :
            tmp$3 = "REFUND";
            break;
          case "RESET" :
            tmp$3 = "RESET";
            break;
          case "SALE" :
            tmp$3 = "SALE";
            break;
          default:
            throw {
              RE_EXN_ID: "Not_found",
              Error: new Error()
            };
        }
        let value$10 = value$1.reason;
        let tmp$4;
        if (value$10 == null) {
          tmp$4 = undefined;
        } else {
          let tmp$5;
          switch (value$10) {
            case "CORKY" :
              tmp$5 = "CORKY";
              break;
            case "DAMAGE" :
              tmp$5 = "DAMAGE";
              break;
            case "LOSS" :
              tmp$5 = "LOSS";
              break;
            case "OTHER" :
              tmp$5 = "OTHER";
              break;
            case "OUTDATED_DLUO" :
              tmp$5 = "OUTDATED_DLUO";
              break;
            case "SALE_BY_GLASS" :
              tmp$5 = "SALE_BY_GLASS";
              break;
            case "TASTING" :
              tmp$5 = "TASTING";
              break;
            case "THEFT" :
              tmp$5 = "THEFT";
              break;
            case "TRADE_IN_SUPPLIER" :
              tmp$5 = "TRADE_IN_SUPPLIER";
              break;
            default:
              throw {
                RE_EXN_ID: "Not_found",
                Error: new Error()
              };
          }
          tmp$4 = tmp$5;
        }
        let value$11 = value$1.comment;
        let value$12 = value$1.shop;
        let value$13 = value$1.device;
        return {
          __typename: value.__typename,
          node: {
            __typename: value$1.__typename,
            id: value$1.id,
            variant: tmp,
            kind: tmp$3,
            reason: tmp$4,
            comment: !(value$11 == null) ? Scalar.Text.parse(value$11) : undefined,
            quantity: value$1.quantity,
            createdAt: Scalar.Datetime.parse(value$1.createdAt),
            shop: {
              __typename: value$12.__typename,
              name: value$12.name
            },
            device: {
              __typename: value$13.__typename,
              name: value$13.name,
              slug: value$13.slug
            }
          }
        };
      }),
      totalCount: value$1.totalCount
    }
  };
}

function serialize(value) {
  let value$1 = value.stockActivities;
  let value$2 = value$1.totalCount;
  let value$3 = value$1.edges;
  let edges = value$3.map(value => {
    let value$1 = value.node;
    let value$2 = value$1.device;
    let value$3 = value$2.slug;
    let value$4 = value$2.name;
    let value$5 = value$2.__typename;
    let device = {
      __typename: value$5,
      name: value$4,
      slug: value$3
    };
    let value$6 = value$1.shop;
    let value$7 = value$6.name;
    let value$8 = value$6.__typename;
    let shop = {
      __typename: value$8,
      name: value$7
    };
    let value$9 = value$1.createdAt;
    let value$10 = Scalar.Datetime.serialize(value$9);
    let value$11 = value$1.quantity;
    let value$12 = value$1.comment;
    let comment = value$12 !== undefined ? Scalar.Text.serialize(value$12) : null;
    let value$13 = value$1.reason;
    let reason = value$13 !== undefined ? (
        value$13 === "DAMAGE" ? "DAMAGE" : (
            value$13 === "OUTDATED_DLUO" ? "OUTDATED_DLUO" : (
                value$13 === "SALE_BY_GLASS" ? "SALE_BY_GLASS" : (
                    value$13 === "THEFT" ? "THEFT" : (
                        value$13 === "TASTING" ? "TASTING" : (
                            value$13 === "LOSS" ? "LOSS" : (
                                value$13 === "OTHER" ? "OTHER" : (
                                    value$13 === "TRADE_IN_SUPPLIER" ? "TRADE_IN_SUPPLIER" : "CORKY"
                                  )
                              )
                          )
                      )
                  )
              )
          )
      ) : null;
    let value$14 = value$1.kind;
    let kind = value$14 === "DELIVERY_RECEIPT" ? "DELIVERY_RECEIPT" : (
        value$14 === "RESET" ? "RESET" : (
            value$14 === "INCOMING_TRANSFER" ? "INCOMING_TRANSFER" : (
                value$14 === "DELIVERY" ? "DELIVERY" : (
                    value$14 === "REFUND" ? "REFUND" : (
                        value$14 === "LOSS" ? "LOSS" : (
                            value$14 === "CREDIT_MEMO" ? "CREDIT_MEMO" : (
                                value$14 === "SALE" ? "SALE" : (
                                    value$14 === "RECEPTION" ? "RECEPTION" : "OUTGOING_TRANSFER"
                                  )
                              )
                          )
                      )
                  )
              )
          )
      );
    let value$15 = value$1.variant;
    let variant;
    if (value$15 !== undefined) {
      let value$16 = value$15.product;
      let value$17 = value$16.color;
      let color = value$17 !== undefined ? (
          value$17 === "ORANGE" ? "ORANGE" : (
              value$17 === "RED" ? "RED" : (
                  value$17 === "AMBER" ? "AMBER" : (
                      value$17 === "DARK" ? "DARK" : (
                          value$17 === "BLACK" ? "BLACK" : (
                              value$17 === "BLOND" ? "BLOND" : (
                                  value$17 === "ROSE" ? "ROSE" : "WHITE"
                                )
                            )
                        )
                    )
                )
            )
        ) : null;
      let value$18 = value$16.__typename;
      let product = {
        __typename: value$18,
        color: color
      };
      let value$19 = value$15.bulk;
      let bulk = value$19 !== undefined ? value$19 : null;
      let value$20 = value$15.capacityUnit;
      let capacityUnit = value$20 !== undefined ? value$20 : null;
      let value$21 = value$15.capacityPrecision;
      let capacityPrecision = value$21 !== undefined ? value$21 : null;
      let value$22 = value$15.stockKeepingUnit;
      let stockKeepingUnit = value$22 !== undefined ? value$22 : null;
      let value$23 = value$15.formattedDescription;
      let value$24 = value$15.formattedName;
      let value$25 = value$15.cku;
      let value$26 = Scalar.CKU.serialize(value$25);
      let value$27 = value$15.id;
      let value$28 = value$15.__typename;
      variant = {
        __typename: value$28,
        id: value$27,
        cku: value$26,
        formattedName: value$24,
        formattedDescription: value$23,
        stockKeepingUnit: stockKeepingUnit,
        capacityPrecision: capacityPrecision,
        capacityUnit: capacityUnit,
        bulk: bulk,
        product: product
      };
    } else {
      variant = null;
    }
    let value$29 = value$1.id;
    let value$30 = value$1.__typename;
    let node = {
      __typename: value$30,
      id: value$29,
      variant: variant,
      kind: kind,
      reason: reason,
      comment: comment,
      quantity: value$11,
      createdAt: value$10,
      shop: shop,
      device: device
    };
    let value$31 = value.__typename;
    return {
      __typename: value$31,
      node: node
    };
  });
  let value$4 = value$1.pageInfo;
  let value$5 = value$4.endCursor;
  let endCursor = value$5 !== undefined ? value$5 : null;
  let value$6 = value$4.startCursor;
  let startCursor = value$6 !== undefined ? value$6 : null;
  let value$7 = value$4.__typename;
  let pageInfo = {
    __typename: value$7,
    startCursor: startCursor,
    endCursor: endCursor
  };
  let value$8 = value$1.__typename;
  let stockActivities = {
    __typename: value$8,
    pageInfo: pageInfo,
    edges: edges,
    totalCount: value$2
  };
  return {
    stockActivities: stockActivities
  };
}

function serializeInputObjectDateFilter(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInOrNotInFilter(inp) {
  let a = inp._in;
  let a$1 = inp._notIn;
  return {
    _in: a !== undefined ? a.map(b => b) : undefined,
    _notIn: a$1 !== undefined ? a$1.map(b => b) : undefined
  };
}

function serializeInputObjectInFilter(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInputStockActivitiesQueryFilter(inp) {
  let a = inp.kind;
  let a$1 = inp.reason;
  let a$2 = inp.date;
  let a$3 = inp.shopIds;
  return {
    kind: a !== undefined ? serializeInputObjectInOrNotInFilter(a) : undefined,
    reason: a$1 !== undefined ? serializeInputObjectInFilter(a$1) : undefined,
    date: a$2 !== undefined ? serializeInputObjectDateFilter(a$2) : undefined,
    shopIds: a$3 !== undefined ? serializeInputObjectInFilter(a$3) : undefined
  };
}

function serializeVariables(inp) {
  let a = inp.search;
  let a$1 = inp.before;
  let a$2 = inp.after;
  let a$3 = inp.first;
  let a$4 = inp.last;
  let a$5 = inp.filterBy;
  return {
    search: a !== undefined ? a : undefined,
    before: a$1 !== undefined ? a$1 : undefined,
    after: a$2 !== undefined ? a$2 : undefined,
    first: a$3 !== undefined ? a$3 : undefined,
    last: a$4 !== undefined ? a$4 : undefined,
    filterBy: a$5 !== undefined ? serializeInputObjectInputStockActivitiesQueryFilter(a$5) : undefined
  };
}

function makeVariables(search, before, after, first, last, filterBy) {
  return {
    search: search,
    before: before,
    after: after,
    first: first,
    last: last,
    filterBy: filterBy
  };
}

function makeInputObjectInputStockActivitiesQueryFilter(kind, reason, date, shopIds, param) {
  return {
    kind: kind,
    reason: reason,
    date: date,
    shopIds: shopIds
  };
}

function makeInputObjectInOrNotInFilter(_in, _notIn, param) {
  return {
    _in: _in,
    _notIn: _notIn
  };
}

function makeInputObjectInFilter(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectDateFilter(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

function makeDefaultVariables() {
  return {
    search: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined,
    filterBy: undefined
  };
}

let Query_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputStockActivitiesQueryFilter: serializeInputObjectInputStockActivitiesQueryFilter,
  serializeInputObjectInOrNotInFilter: serializeInputObjectInOrNotInFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  makeVariables: makeVariables,
  makeInputObjectInputStockActivitiesQueryFilter: makeInputObjectInputStockActivitiesQueryFilter,
  makeInputObjectInOrNotInFilter: makeInputObjectInOrNotInFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeDefaultVariables: makeDefaultVariables
};

let include = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let Query_refetchQueryDescription = include.refetchQueryDescription;

let Query_useLazy = include.useLazy;

let Query_useLazyWithVariables = include.useLazyWithVariables;

let Query = {
  Query_inner: Query_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputStockActivitiesQueryFilter: serializeInputObjectInputStockActivitiesQueryFilter,
  serializeInputObjectInOrNotInFilter: serializeInputObjectInOrNotInFilter,
  serializeInputObjectInFilter: serializeInputObjectInFilter,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter,
  makeVariables: makeVariables,
  makeInputObjectInputStockActivitiesQueryFilter: makeInputObjectInputStockActivitiesQueryFilter,
  makeInputObjectInOrNotInFilter: makeInputObjectInOrNotInFilter,
  makeInputObjectInFilter: makeInputObjectInFilter,
  makeInputObjectDateFilter: makeInputObjectDateFilter,
  makeDefaultVariables: makeDefaultVariables,
  refetchQueryDescription: Query_refetchQueryDescription,
  use: use,
  useLazy: Query_useLazy,
  useLazyWithVariables: Query_useLazyWithVariables
};

function kindToString(kind) {
  if (typeof kind !== "object") {
    return "EXCLUDING_RESET";
  } else {
    return StockActivityKind.toString(kind._0);
  }
}

function kindFromStringExn(value) {
  if (value === "EXCLUDING_RESET") {
    return "ExcludingReset";
  } else {
    return {
      TAG: "Kind",
      _0: StockActivityKind.fromStringExn(value)
    };
  }
}

function encodeValues(values) {
  if (values.length !== 0) {
    return values;
  }
}

function partitionKinds(kinds) {
  return [
    Stdlib_Array.filterMap(kinds, kind => {
      if (typeof kind !== "object") {
        return;
      } else {
        return StockActivityKind.toString(kind._0);
      }
    }),
    kinds.some(kind => kind === "ExcludingReset")
  ];
}

function encoder(param) {
  return [
    Stdlib_Option.map(param.shop, shop => shop.id),
    Stdlib_Option.map(param.dateRange, param => [
      param[0].getTime(),
      param[1].getTime()
    ]),
    encodeValues(param.kinds.map(kindToString)),
    encodeValues(param.reasons.map(StockActivityReason.toString))
  ];
}

function decoder(shops, param) {
  let shopId = param[0];
  return {
    TAG: "Ok",
    _0: {
      shop: shops.find(shop => shop.id === shopId),
      dateRange: Stdlib_Option.flatMap(param[1], range => {
        if (range.length !== 2) {
          return;
        }
        let start = range[0];
        let end = range[1];
        return [
          new Date(start),
          new Date(end)
        ];
      }),
      kinds: Stdlib_Option.getOr(param[2], []).map(kindFromStringExn),
      reasons: Stdlib_Option.getOr(param[3], []).map(StockActivityReason.fromStringExn)
    }
  };
}

function useJsonCodec() {
  let shops = Auth.useShops();
  return JsonCodec.object4(encoder, arg => decoder(shops, arg), JsonCodec.optional(JsonCodec.field("shopId", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("dateRange", JsonCodec.array(JsonCodec.float))), JsonCodec.optional(JsonCodec.field("kinds", JsonCodec.array(JsonCodec.string))), JsonCodec.optional(JsonCodec.field("reasons", JsonCodec.array(JsonCodec.string))));
}

let Filters = {
  kindToString: kindToString,
  kindFromStringExn: kindFromStringExn,
  encodeValues: encodeValues,
  partitionKinds: partitionKinds,
  encoder: encoder,
  decoder: decoder,
  useJsonCodec: useJsonCodec
};

let all = {
  kind: undefined,
  reason: undefined
};

let allButReset = {
  kind: "ExcludingReset",
  reason: undefined
};

function ofKind(value) {
  return {
    kind: {
      TAG: "Kind",
      _0: value
    },
    reason: undefined
  };
}

function ofLossReason(value) {
  return {
    kind: {
      TAG: "Kind",
      _0: "LOSS"
    },
    reason: value
  };
}

function isLossReason(param) {
  return Stdlib_Option.isSome(param.reason);
}

function ofFilters(param) {
  let reasons = param.reasons;
  let kinds = param.kinds;
  if (kinds.length === 0 && reasons.length === 0) {
    return [all];
  }
  return kinds.flatMap(kind => {
    if (typeof kind !== "object") {
      return [allButReset];
    }
    let value = kind._0;
    if (value === "LOSS") {
      if (reasons.length !== 0) {
        return [];
      } else {
        return StockActivityReason.values.map(ofLossReason);
      }
    } else {
      return [ofKind(value)];
    }
  }).concat(reasons.map(ofLossReason));
}

function toFilters(values) {
  let kinds = Stdlib_Array.reduce(values, [], (acc, param) => {
    let kind = param.kind;
    if (kind !== undefined && !acc.some(value => Primitive_object.equal(value, kind))) {
      return acc.concat([kind]);
    } else {
      return acc;
    }
  });
  let reasons = Stdlib_Array.filterMap(values, param => param.reason);
  let everyReasonSelected = StockActivityReason.values.every(value => reasons.includes(value));
  return [
    kinds,
    everyReasonSelected ? [] : reasons
  ];
}

let KindFilter = {
  all: all,
  allButReset: allButReset,
  ofKind: ofKind,
  ofLossReason: ofLossReason,
  isLossReason: isLossReason,
  ofFilters: ofFilters,
  toFilters: toFilters
};

let Row = {};

let make = React.memo(props => {
  let notification = props.notification;
  if (notification === undefined) {
    return null;
  }
  let onRequestClose = props.onRequestClose;
  let tmp;
  tmp = notification.TAG === "Ok" ? JsxRuntime.jsx(Banner.make, {
      textStatus: {
        TAG: "Success",
        _0: notification._0
      },
      onRequestClose: onRequestClose
    }) : JsxRuntime.jsx(Banner.make, {
      textStatus: {
        TAG: "Danger",
        _0: notification._0
      },
      onRequestClose: onRequestClose
    });
  return JsxRuntime.jsx(Box.make, {
    children: tmp,
    spaceTop: "medium"
  });
});

let StockActivityNotificationBanner = {
  make: make
};

let Raw$1 = {};

let query$1 = Client.gql(["query StockActivityExportTotalCountQuery($filterBy: InputStockActivitiesQueryFilter)  {\nstockActivities(filterBy: $filterBy)  {\n__typename  \ntotalCount  \n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.stockActivities;
  return {
    stockActivities: {
      __typename: value$1.__typename,
      totalCount: value$1.totalCount
    }
  };
}

function serialize$1(value) {
  let value$1 = value.stockActivities;
  let value$2 = value$1.totalCount;
  let value$3 = value$1.__typename;
  let stockActivities = {
    __typename: value$3,
    totalCount: value$2
  };
  return {
    stockActivities: stockActivities
  };
}

function serializeInputObjectInFilter$1(inp) {
  let a = inp._in;
  return {
    _in: a.map(b => b)
  };
}

function serializeInputObjectInOrNotInFilter$1(inp) {
  let a = inp._in;
  let a$1 = inp._notIn;
  return {
    _in: a !== undefined ? a.map(b => b) : undefined,
    _notIn: a$1 !== undefined ? a$1.map(b => b) : undefined
  };
}

function serializeInputObjectDateFilter$1(inp) {
  let a = inp._after;
  let a$1 = inp._before;
  let a$2 = inp._between;
  return {
    _after: a !== undefined ? a : undefined,
    _before: a$1 !== undefined ? a$1 : undefined,
    _between: a$2 !== undefined ? a$2.map(b => b) : undefined
  };
}

function serializeInputObjectInputStockActivitiesQueryFilter$1(inp) {
  let a = inp.kind;
  let a$1 = inp.reason;
  let a$2 = inp.date;
  let a$3 = inp.shopIds;
  return {
    kind: a !== undefined ? serializeInputObjectInOrNotInFilter$1(a) : undefined,
    reason: a$1 !== undefined ? serializeInputObjectInFilter$1(a$1) : undefined,
    date: a$2 !== undefined ? serializeInputObjectDateFilter$1(a$2) : undefined,
    shopIds: a$3 !== undefined ? serializeInputObjectInFilter$1(a$3) : undefined
  };
}

function serializeVariables$1(inp) {
  let a = inp.filterBy;
  return {
    filterBy: a !== undefined ? serializeInputObjectInputStockActivitiesQueryFilter$1(a) : undefined
  };
}

function makeVariables$1(filterBy) {
  return {
    filterBy: filterBy
  };
}

function makeInputObjectInputStockActivitiesQueryFilter$1(kind, reason, date, shopIds, param) {
  return {
    kind: kind,
    reason: reason,
    date: date,
    shopIds: shopIds
  };
}

function makeInputObjectInOrNotInFilter$1(_in, _notIn, param) {
  return {
    _in: _in,
    _notIn: _notIn
  };
}

function makeInputObjectInFilter$1(_in, param) {
  return {
    _in: _in
  };
}

function makeInputObjectDateFilter$1(_after, _before, _between, param) {
  return {
    _after: _after,
    _before: _before,
    _between: _between
  };
}

function makeDefaultVariables$1() {
  return {
    filterBy: undefined
  };
}

let StockActivityExportTotalCountQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputStockActivitiesQueryFilter: serializeInputObjectInputStockActivitiesQueryFilter$1,
  serializeInputObjectInOrNotInFilter: serializeInputObjectInOrNotInFilter$1,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter$1,
  makeVariables: makeVariables$1,
  makeInputObjectInputStockActivitiesQueryFilter: makeInputObjectInputStockActivitiesQueryFilter$1,
  makeInputObjectInOrNotInFilter: makeInputObjectInOrNotInFilter$1,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectDateFilter: makeInputObjectDateFilter$1,
  makeDefaultVariables: makeDefaultVariables$1
};

let include$1 = ApolloClient__React_Hooks_UseQuery.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let StockActivityExportTotalCountQuery_refetchQueryDescription = include$1.refetchQueryDescription;

let StockActivityExportTotalCountQuery_useLazy = include$1.useLazy;

let StockActivityExportTotalCountQuery_useLazyWithVariables = include$1.useLazyWithVariables;

let StockActivityExportTotalCountQuery = {
  StockActivityExportTotalCountQuery_inner: StockActivityExportTotalCountQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  serializeInputObjectInputStockActivitiesQueryFilter: serializeInputObjectInputStockActivitiesQueryFilter$1,
  serializeInputObjectInOrNotInFilter: serializeInputObjectInOrNotInFilter$1,
  serializeInputObjectInFilter: serializeInputObjectInFilter$1,
  serializeInputObjectDateFilter: serializeInputObjectDateFilter$1,
  makeVariables: makeVariables$1,
  makeInputObjectInputStockActivitiesQueryFilter: makeInputObjectInputStockActivitiesQueryFilter$1,
  makeInputObjectInOrNotInFilter: makeInputObjectInOrNotInFilter$1,
  makeInputObjectInFilter: makeInputObjectInFilter$1,
  makeInputObjectDateFilter: makeInputObjectDateFilter$1,
  makeDefaultVariables: makeDefaultVariables$1,
  refetchQueryDescription: StockActivityExportTotalCountQuery_refetchQueryDescription,
  use: use$1,
  useLazy: StockActivityExportTotalCountQuery_useLazy,
  useLazyWithVariables: StockActivityExportTotalCountQuery_useLazyWithVariables
};

let endpoint = Env.sheetUrl() + "/stock-movements-history";

function encodeRequestBodyJson(shopIds, kindsOpt, reasonsOpt, dateRange, param) {
  let kinds = kindsOpt !== undefined ? kindsOpt : [];
  let reasons = reasonsOpt !== undefined ? reasonsOpt : [];
  let body = {};
  body["shopIds"] = Json.encodeArray(shopIds.map(Json.encodeString));
  let match = partitionKinds(kinds);
  let kindValues = match[0];
  if (kindValues.length !== 0) {
    body["stockActivityKind"] = Json.encodeArray(kindValues.map(Json.encodeString));
  }
  if (match[1]) {
    body["stockActivityNotKind"] = Json.encodeString(StockActivityKind.toString("RESET"));
  }
  if (reasons.length !== 0) {
    body["stockActivityLossReason"] = Json.encodeArray(reasons.map(reason => Json.encodeString(StockActivityReason.toString(reason))));
  }
  if (dateRange !== undefined) {
    body["startDate"] = Json.encodeString(dateRange[0].toISOString());
    body["endDate"] = Json.encodeString(dateRange[1].toISOString());
  }
  body["timeZone"] = Json.encodeString(I18n.timeZone);
  return Json.encodeDict(body);
}

function make$1(shopIds, kindsOpt, reasonsOpt, dateRange, param) {
  let kinds = kindsOpt !== undefined ? kindsOpt : [];
  let reasons = reasonsOpt !== undefined ? reasonsOpt : [];
  return Request.make(endpoint, "POST", {
    TAG: "JsonBody",
    _0: encodeRequestBodyJson(shopIds, kinds, reasons, dateRange, undefined)
  }, undefined, undefined);
}

function queryVariables(shopIds, kindsOpt, reasonsOpt, dateRange, param) {
  let kinds = kindsOpt !== undefined ? kindsOpt : [];
  let reasons = reasonsOpt !== undefined ? reasonsOpt : [];
  let match = partitionKinds(kinds);
  let values = match[0];
  let tmp;
  let exit = 0;
  if (values.length !== 0 || match[1]) {
    exit = 1;
  } else {
    tmp = undefined;
  }
  if (exit === 1) {
    tmp = {
      _in: encodeValues(values),
      _notIn: match[1] ? [StockActivityKind.toString("RESET")] : undefined
    };
  }
  return {
    filterBy: makeInputObjectInputStockActivitiesQueryFilter$1(tmp, Stdlib_Option.map(encodeValues(reasons.map(StockActivityReason.toString)), values => ({
      _in: values
    })), dateRange !== undefined ? ({
        _after: undefined,
        _before: undefined,
        _between: [
          Scalar.Datetime.serialize(dateRange[0]),
          Scalar.Datetime.serialize(dateRange[1])
        ]
      }) : undefined, {
      _in: shopIds
    }, undefined)
  };
}

function mapError(param) {
  return "UnexpectedFailure";
}

function messageFromError(error) {
  if (typeof error !== "object") {
    if (error === "NothingToBeExported") {
      return I18n.t("stock_activity_page.export_request.nothing_to_be_exported");
    } else {
      return I18n.t("stock_activity_page.export_request.unexpected_failure");
    }
  } else {
    return I18n.template(I18n.t("stock_activity_page.export_request.file_too_large_to_be_exported {{stockActivitiesCount}} {{stockActivitiesLimit}}"), {
      stockActivitiesCount: I18n.decimalFormat(undefined, undefined, undefined, undefined, error._0),
      stockActivitiesLimit: I18n.decimalFormat(undefined, undefined, undefined, undefined, error._1)
    }, undefined);
  }
}

function useDownload(shopIds, kindsOpt, reasonsOpt, dateRange, request) {
  let kinds = kindsOpt !== undefined ? kindsOpt : [];
  let reasons = reasonsOpt !== undefined ? reasonsOpt : [];
  let captureEvent = SessionTracker.useCaptureEvent();
  let queryResults = use$1(undefined, undefined, undefined, undefined, "CacheAndNetwork", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, queryVariables(shopIds, kinds, reasons, dateRange, undefined));
  let request$1 = () => {
    captureEvent("download_stock_activity_export_file");
    return request(shopIds, encodeValues(kinds), encodeValues(reasons), dateRange, undefined);
  };
  let match = RequestOpenStorageUrl.use(request$1, undefined, undefined);
  let match$1 = queryResults.data;
  let stockActivitiesCount = match$1 !== undefined ? match$1.stockActivities.totalCount : 0;
  let result = stockActivitiesCount === 0 ? ({
      TAG: "Done",
      _0: {
        TAG: "Error",
        _0: "NothingToBeExported"
      }
    }) : (
      stockActivitiesCount > 10000 ? ({
          TAG: "Done",
          _0: {
            TAG: "Error",
            _0: {
              TAG: "FileTooLargeToBeExported",
              _0: stockActivitiesCount,
              _1: 10000
            }
          }
        }) : AsyncResult.mapError(match[0], mapError)
    );
  return [
    result,
    match[1]
  ];
}

function StockActivityPage$StockActivityExportRequest$Button(props) {
  let onRequestNotification = props.onRequestNotification;
  let shops = Auth.useShops();
  let activeShop = Auth.useActiveShop();
  let match = props.state.filters;
  let shop = match.shop;
  let shopIds = shop !== undefined ? [shop.id] : shops.map(shop => shop.id);
  let match$1 = useDownload(shopIds, match.kinds, match.reasons, match.dateRange, props.request);
  let requestAndDownload = match$1[1];
  let operationResult = match$1[0];
  React.useEffect(() => {
    if (typeof operationResult === "object" && operationResult.TAG === "Done") {
      let error = operationResult._0;
      if (error.TAG === "Ok") {
        onRequestNotification({
          TAG: "Ok",
          _0: I18n.t("The file has been downloaded successfully.")
        });
      } else {
        let error$1 = error._0;
        if (typeof error$1 !== "object" && error$1 !== "NothingToBeExported") {
          onRequestNotification({
            TAG: "Error",
            _0: messageFromError(error$1)
          });
        }
      }
    }
  }, [AsyncResult.isDone(operationResult)]);
  let disabled;
  if (typeof operationResult !== "object" || operationResult.TAG !== "Done") {
    disabled = Stdlib_Option.isNone(activeShop);
  } else {
    let match$2 = operationResult._0;
    if (match$2.TAG === "Ok") {
      disabled = Stdlib_Option.isNone(activeShop);
    } else {
      let tmp = match$2._0;
      disabled = typeof tmp !== "object" && tmp !== "NothingToBeExported" ? Stdlib_Option.isNone(activeShop) : true;
    }
  }
  let tmp$1;
  if (Stdlib_Option.isNone(activeShop)) {
    tmp$1 = I18n.t("Please select a shop beforehand.");
  } else if (typeof operationResult !== "object" || operationResult.TAG !== "Done") {
    tmp$1 = "";
  } else {
    let error = operationResult._0;
    tmp$1 = error.TAG === "Ok" ? "" : messageFromError(error._0);
  }
  return JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Button.make, {
      label: I18n.t("Export"),
      size: "legacy_large",
      disabled: disabled,
      pending: AsyncData.isBusy(operationResult),
      icon: "export",
      onPress: () => requestAndDownload()
    }),
    placement: "start",
    content: JsxRuntime.jsx(Tooltip.Span.make, {
      text: tmp$1
    }),
    disabled: !disabled,
    delay: 350
  });
}

let Button$1 = {
  make: StockActivityPage$StockActivityExportRequest$Button
};

let StockActivityExportRequest = {
  totalCountLimit: 10000,
  StockActivityExportTotalCountQuery: StockActivityExportTotalCountQuery,
  endpoint: endpoint,
  encodeRequestBodyJson: encodeRequestBodyJson,
  make: make$1,
  queryVariables: queryVariables,
  mapError: mapError,
  messageFromError: messageFromError,
  useDownload: useDownload,
  Button: Button$1
};

function makeQueryVariables(_defaultQueryVariables, connectionArguments, search, filterBy, param) {
  return {
    search: search,
    before: connectionArguments.before,
    after: connectionArguments.after,
    first: connectionArguments.first,
    last: connectionArguments.last,
    filterBy: filterBy
  };
}

function makeQueryVariablesFilterBy(param) {
  let dateRange = param.dateRange;
  let shop = param.shop;
  let match = partitionKinds(param.kinds);
  let values = match[0];
  let tmp;
  let exit = 0;
  if (values.length !== 0 || match[1]) {
    exit = 1;
  } else {
    tmp = undefined;
  }
  if (exit === 1) {
    tmp = {
      _in: encodeValues(values),
      _notIn: match[1] ? [StockActivityKind.toString("RESET")] : undefined
    };
  }
  return makeInputObjectInputStockActivitiesQueryFilter(tmp, Stdlib_Option.map(encodeValues(param.reasons.map(StockActivityReason.toString)), values => ({
    _in: values
  })), dateRange !== undefined ? ({
      _after: undefined,
      _before: undefined,
      _between: [
        Scalar.Datetime.serialize(dateRange[0]),
        Scalar.Datetime.serialize(dateRange[1])
      ]
    }) : undefined, shop !== undefined ? ({
      _in: [shop.id]
    }) : undefined, undefined);
}

function totalCountFromQueryData(param) {
  return param.stockActivities.totalCount;
}

function cursorsFromQueryData(param) {
  let stockActivities = param.stockActivities;
  return [
    stockActivities.pageInfo.startCursor,
    stockActivities.pageInfo.endCursor
  ];
}

function rowsFromQueryDataAndState(param, param$1) {
  return Stdlib_Array.filterMap(param.stockActivities.edges, param => {
    let node = param.node;
    let variant = node.variant;
    if (variant === undefined) {
      return;
    }
    let match = variant.bulk;
    let match$1 = variant.capacityPrecision;
    let match$2 = variant.bulk;
    let match$3 = variant.capacityUnit;
    return {
      id: node.id,
      variantId: variant.id,
      variantCku: variant.cku,
      variantName: variant.formattedName,
      variantDescription: variant.formattedDescription,
      variantStockKeepingUnit: variant.stockKeepingUnit,
      variantCapacityPrecision: match !== undefined && match && match$1 !== undefined ? match$1 : undefined,
      variantCapacityUnit: match$2 !== undefined && match$2 && match$3 !== undefined ? match$3 : undefined,
      color: Stdlib_Option.flatMap(Stdlib_Option.map(node.variant, variant => variant.product), product => product.color),
      formattedKind: StockActivityKind.toLabel(node.kind),
      kind: node.kind,
      reason: node.reason,
      quantity: node.quantity,
      description: node.comment,
      date: node.createdAt,
      shopName: node.shop.name,
      deviceName: DeviceName.format(DeviceName.decode(node.device.slug, node.device.name))
    };
  });
}

function keyExtractor(param) {
  return param.id;
}

let Scaffolded = Scaffold.Make({
  useFiltersJsonCodec: useJsonCodec,
  QueryInner: Query_inner,
  useQuery: use,
  makeQueryVariables: makeQueryVariables,
  makeQueryVariablesFilterBy: makeQueryVariablesFilterBy,
  cursorsFromQueryData: cursorsFromQueryData,
  totalCountFromQueryData: totalCountFromQueryData,
  rowsFromQueryDataAndState: rowsFromQueryDataAndState,
  keyExtractor: keyExtractor
});

function use$2(initialState) {
  let match = Scaffolded.use(() => initialState);
  let dispatch = match[1];
  let state = match[0];
  React.useEffect(() => {
    let match = state.filters;
    if (match.kinds.some(kind => Primitive_object.equal(kind, {
        TAG: "Kind",
        _0: "LOSS"
      })) || match.reasons.length === 0) {
      
    } else {
      dispatch({
        TAG: "FiltersUpdated",
        _0: prev => ({
          shop: prev.shop,
          dateRange: prev.dateRange,
          kinds: prev.kinds,
          reasons: []
        })
      });
    }
  }, [state.filters]);
  return [
    state,
    dispatch
  ];
}

function StockActivityPage(props) {
  let __exportRequest = props.exportRequest;
  let exportRequest = __exportRequest !== undefined ? __exportRequest : make$1;
  let activeShop = Auth.useActiveShop();
  let scope = Auth.useScope();
  let organisationAccount;
  organisationAccount = scope.TAG === "Organisation";
  let tmp;
  tmp = scope.TAG === "Organisation" ? scope.activeShop : scope._0;
  let initialState = Scaffolded.makeInitialState({
    shop: tmp,
    dateRange: undefined,
    kinds: [],
    reasons: []
  });
  let match = use$2(initialState);
  let dispatch = match[1];
  let state = match[0];
  let defaultQueryVariables = {
    search: undefined,
    before: undefined,
    after: undefined,
    first: undefined,
    last: undefined,
    filterBy: undefined
  };
  let match$1 = React.useState(() => {});
  let setNotification = match$1[1];
  let columns = [
    {
      name: I18n.t("Product name and description"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 250
        },
        width: {
          NAME: "pct",
          VAL: 30
        },
        margin: "xxlarge",
        sticky: true
      },
      render: activity => {
        let pastilleColor = Stdlib_Option.map(activity.color, color => CatalogProduct.Color.toColorSet(color, "pastille").foregroundColor);
        let description = Stdlib_Option.mapOr(activity.variantStockKeepingUnit, "", sku => `SKU` + I18n.t(":") + ` ` + sku + `, `) + activity.variantDescription;
        return JsxRuntime.jsx(LegacyProductReferenceTableCell.make, {
          cku: activity.variantCku,
          name: activity.variantName,
          pastilleColor: pastilleColor,
          description: description
        });
      }
    },
    {
      name: I18n.t("Type"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 120
        },
        width: {
          NAME: "fr",
          VAL: 0.5
        }
      },
      render: param => JsxRuntime.jsx(StockActivityTypeTableCell.make, {
        value: param.formattedKind,
        reason: param.reason
      })
    },
    {
      name: I18n.t("Quantity"),
      layout: {
        width: {
          NAME: "fr",
          VAL: 0.5
        },
        alignX: "center",
        sticky: true
      },
      render: param => JsxRuntime.jsx(StockActivityQuantityTableCell.make, {
        value: param.quantity,
        capacityPrecision: param.variantCapacityPrecision,
        capacityUnit: param.variantCapacityUnit,
        kind: param.kind
      })
    },
    {
      name: I18n.t("Comment"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 100
        },
        margin: "normal"
      },
      render: param => JsxRuntime.jsx(TextStyle.make, {
        children: Stdlib_Option.getOr(param.description, "—")
      })
    },
    {
      name: I18n.t("Datetime"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 110
        }
      },
      render: param => JsxRuntime.jsx(TableDatetimeCell.make, {
        value: param.date
      })
    },
    {
      name: I18n.t("Source"),
      layout: {
        minWidth: {
          NAME: "px",
          VAL: 120
        }
      },
      render: param => {
        let shopName;
        shopName = scope.TAG === "Organisation" ? param.shopName : undefined;
        return JsxRuntime.jsx(StockActivitySourceTableCell.make, {
          deviceName: param.deviceName,
          shopName: shopName
        });
      }
    }
  ];
  let defaultItem_1 = I18n.t("All");
  let defaultItem_4 = true;
  let defaultItem = {
    TAG: "Option",
    key: "default",
    label: defaultItem_1,
    value: all,
    exclusive: defaultItem_4
  };
  let excludingResetItem_1 = I18n.t("All but reset");
  let excludingResetItem_4 = true;
  let excludingResetItem = {
    TAG: "Option",
    key: "excluding-reset",
    label: excludingResetItem_1,
    value: allButReset,
    exclusive: excludingResetItem_4
  };
  let lossItem_1 = StockActivityKind.toLabel("LOSS");
  let lossItem_2 = StockActivityReason.values.map(value => ({
    TAG: "Option",
    key: `reason-` + StockActivityReason.toString(value),
    label: StockActivityReason.toLabel(value),
    value: {
      kind: {
        TAG: "Kind",
        _0: "LOSS"
      },
      reason: value
    }
  }));
  let lossItem = {
    TAG: "Submenu",
    key: "kind-LOSS",
    label: lossItem_1,
    items: lossItem_2
  };
  let items = StockActivityKind.values.map(value => {
    if (value === "LOSS") {
      return lossItem;
    } else {
      return {
        TAG: "Option",
        key: `kind-` + StockActivityKind.toString(value),
        label: StockActivityKind.toLabel(value),
        value: ofKind(value)
      };
    }
  });
  let match$2 = state.filters;
  let filters = JsxRuntime.jsxs(Inline.make, {
    children: [
      organisationAccount ? JsxRuntime.jsx(Auth.SelectShopFilter.make, {
          value: state.filters.shop,
          onChange: shop => dispatch({
            TAG: "FiltersUpdated",
            _0: prev => ({
              shop: shop,
              dateRange: prev.dateRange,
              kinds: prev.kinds,
              reasons: prev.reasons
            })
          })
        }) : null,
      organisationAccount ? JsxRuntime.jsx(CanarySeparator.make, {}) : null,
      JsxRuntime.jsx(Select.make, {
        label: I18n.t("Kind"),
        preset: "filter",
        shouldSelectTogether: (value, other) => isLossReason(value) === isLossReason(other),
        renderValue: param => {
          let selectedItems = param.selectedItems;
          let len = selectedItems.length;
          if (len !== 1) {
            if (len === 0) {
              return I18n.t("All");
            }
          } else {
            let match = selectedItems[0];
            if (match.TAG === "Option") {
              let label = match.label;
              if (match.value.reason !== undefined) {
                return StockActivityKind.toLabel("LOSS") + ` › ` + label;
              } else {
                return label;
              }
            }
          }
          return JsxRuntime.jsx(CountBadge.make, {
            children: selectedItems.length.toString(),
            size: "small",
            tone: "brand"
          });
        },
        sections: [
          {
            items: [
              defaultItem,
              excludingResetItem
            ]
          },
          {
            items: items,
            title: I18n.t("Kinds")
          }
        ],
        value: {
          TAG: "Multiple",
          _0: ofFilters(state.filters)
        },
        onChange: change => {
          if (change.TAG === "Single") {
            return;
          }
          let match = toFilters(change._0);
          let reasons = match[1];
          let kinds = match[0];
          dispatch({
            TAG: "FiltersUpdated",
            _0: prev => ({
              shop: prev.shop,
              dateRange: prev.dateRange,
              kinds: kinds,
              reasons: reasons
            })
          });
        }
      }),
      JsxRuntime.jsx(SelectDateRangeFilter.make, {
        value: state.filters.dateRange,
        placeholder: I18n.t("Since the beginning"),
        onChange: dateRange => dispatch({
          TAG: "FiltersUpdated",
          _0: prev => ({
            shop: prev.shop,
            dateRange: dateRange,
            kinds: prev.kinds,
            reasons: prev.reasons
          })
        }),
        triggerLabelDisplay: "showPreset"
      }),
      (
        match$2.dateRange !== undefined ? true : match$2.kinds.length !== 0
      ) ? JsxRuntime.jsx(Scaffold.ResetFiltersButton.make, {
          onPress: () => dispatch({
            TAG: "FiltersUpdated",
            _0: param => initialState.filters
          })
        }) : null
    ],
    space: "small"
  });
  let actions = JsxRuntime.jsx(StockActivityPage$StockActivityExportRequest$Button, {
    request: exportRequest,
    state: state,
    onRequestNotification: result => setNotification(param => result)
  });
  let banner = JsxRuntime.jsx(make, {
    notification: match$1[0],
    onRequestClose: () => setNotification(param => {})
  });
  let searchBar = JsxRuntime.jsx(SearchBar.make, {
    placeholder: I18n.t("Search a stock movement"),
    value: state.searchQuery,
    onChange: searchQuery => dispatch({
      TAG: "Searched",
      _0: searchQuery
    })
  });
  let emptyState;
  let exit = 0;
  if (state.currentPage !== 1 || state.searchQuery !== undefined) {
    exit = 1;
  } else {
    let match$3 = state.filters;
    if (match$3.dateRange !== undefined || match$3.kinds.length !== 0 || match$3.reasons.length !== 0 || match$3.shop !== activeShop) {
      exit = 1;
    } else {
      emptyState = JsxRuntime.jsx(EmptyState.make, {
        illustration: Illustration.create,
        title: I18n.t("Welcome to the stock movements space.")
      });
    }
  }
  if (exit === 1) {
    emptyState = JsxRuntime.jsx(EmptyState.make, {
      illustration: Illustration.noResultFound,
      title: I18n.t("No result were found."),
      text: I18n.t("Try again with another keyword/filter or:"),
      children: JsxRuntime.jsx(Button.make, {
        label: I18n.t("Clear search query and filters"),
        onPress: () => dispatch({
          TAG: "Reset",
          _0: initialState
        })
      })
    });
  }
  return JsxRuntime.jsx(Scaffolded.make, {
    title: I18n.t("Stock activities"),
    state: state,
    dispatch: dispatch,
    columns: columns,
    filters: filters,
    actions: actions,
    banner: banner,
    searchBar: searchBar,
    emptyState: emptyState,
    defaultQueryVariables: defaultQueryVariables
  });
}

let make$2 = React.memo(StockActivityPage);

export {
  Query,
  Filters,
  KindFilter,
  Row,
  StockActivityNotificationBanner,
  StockActivityExportRequest,
  Scaffolded,
  use$2 as use,
  make$2 as make,
}
/* query Not a pure module */
